import { BoxProps, TextNewProps } from '@jfs/ui-new'

export const styles = {
  headerTitle: {
    fontSize: 18,
    lineHeight: 24,
    fontFamily: 'jiotype-medium',
    color: 'BLACK_21',
    textAlign: 'center',
  } as TextNewProps,
  previewText: {
    fontSize: 12,
    lineHeight: 20,
    fontFamily: 'jiotype-medium',
    color: 'BLACK_75',
    textAlign: 'center',
  } as TextNewProps,
  boxContainer: {
    ph: 40,
    pv: 20,
    bg: 'WHITE',
  } as BoxProps,
}
